const SSGA_EXPERIENCE_TYPES = {
  MODEL: 'model',
  ELECTION: 'election',
};

export default SSGA_EXPERIENCE_TYPES;
